(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bt-brand-selection-refresh"] && !Shopify.designMode) return;
  try {
    
class BtBrandRefresh extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const cards = [...this.querySelectorAll('[data-brand-card]')];
    const filters = [...this.querySelectorAll('[data-all],[data-filter]')];
    const input = this.querySelector('[data-search]');
    const all = this.querySelector('[data-all]');
    const reset = this.querySelector('[data-reset]');
    const heading = this.querySelector('[data-directory-heading]');
    if (!input || !all || !reset || !heading) return;
    let selected = all;
    const normalize = value => value.normalize('NFKC').toLocaleLowerCase().trim();
    const urlKey = value => {
      try { return new URL(value, window.location.href).pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '').replace(/\/$/, ''); }
      catch { return ''; }
    };
    const render = () => {
      const term = normalize(input.value);
      const rows = (selected.dataset.rows || '').split(/\r?\n/).filter(row => row.trim()).map(row => row.split('|'));
      const paths = new Set(rows.map(parts => urlKey((parts[3] || '').trim())).filter(Boolean));
      const names = new Set(rows.map(parts => normalize(parts[0] || '')));
      let count = 0;
      cards.forEach(card => {
        const inGroup = selected === all || paths.has(urlKey(card.getAttribute('href') || '')) || names.has(normalize(card.dataset.name || ''));
        const visible = inGroup && normalize(card.dataset.searchText || '').includes(term);
        card.hidden = !visible;
        if (visible) count++;
      });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button === selected)));
      this.querySelector('[data-result-label]').textContent = selected.dataset.label || '';
      this.querySelector('[data-count]').textContent = String(count);
      this.querySelector('[data-empty]').hidden = count > 0;
      reset.hidden = selected === all && !term;
    };
    filters.forEach(button => button.addEventListener('click', () => { selected = button; render(); }));
    input.addEventListener('input', render);
    reset.addEventListener('click', () => { selected = all; input.value = ''; render(); input.focus(); });
    this.querySelectorAll('[data-choice]').forEach(button => button.addEventListener('click', () => {
      selected = button;
      input.value = '';
      render();
      heading.focus({ preventScroll: true });
      this.querySelector('.directory').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    }));
    this.querySelectorAll('[data-controls]').forEach(control => { control.hidden = false; });
    render();
  }
}
if (!customElements.get('bt-brand-refresh')) customElements.define('bt-brand-refresh', BtBrandRefresh);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-cs-contact-v1"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bt-cs-contact-v1'))customElements.define('bt-cs-contact-v1',class extends HTMLElement{
connectedCallback(){
if(this.abort)return;this.abort=new AbortController();const options={signal:this.abort.signal};this.preview=this.dataset.preview==='true';
this.addEventListener('click',event=>{const button=event.target.closest('button');if(!button)return;if(button.hasAttribute('data-open-chat'))this.openChat(button);if(button.hasAttribute('data-form-jump'))this.jumpToForm();if(button.dataset.help){const open=button.getAttribute('aria-expanded')!=='true';this.querySelectorAll('[data-help]').forEach(other=>{const active=other===button&&open;other.setAttribute('aria-expanded',String(active));other.querySelector('strong span').textContent=active?'−':'＋';this.querySelector('[data-answer='+other.dataset.help+']').hidden=!active;});}if(button.dataset.category&&!this.category)this.jumpToForm();},options);
this.form=this.querySelector('[data-form]')||this.querySelector('form');if(!this.form)return;this.category=this.querySelector('[data-field=category]');this.editor=this.querySelector('[data-editor]');this.review=this.querySelector('[data-review]');if(!this.category||!this.editor||!this.review)return;this.phase='edit';
this.querySelector('[data-confirm]').textContent=this.dataset.confirmLabel+' →';
this.addEventListener('click',event=>{const button=event.target.closest('button');if(!button)return;
if(button.dataset.category){this.phase='edit';this.editor.hidden=false;this.review.hidden=true;this.querySelector('[data-preview-feedback]').hidden=true;this.category.value=button.dataset.category;this.update();const area=this.querySelector('.bt-cs__form-wrap');area.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});this.category.focus({preventScroll:true});}
if(button.hasAttribute('data-edit')){this.phase='edit';this.editor.hidden=false;this.review.hidden=true;this.querySelector('[data-preview-feedback]').hidden=true;this.category.focus();}
if(button.hasAttribute('data-confirm'))this.confirm();
if(this.preview&&button.hasAttribute('data-preview-done')){this.querySelector('[data-preview-feedback]').hidden=false;this.querySelector('[data-preview-feedback]').focus();}
},options);
this.category.addEventListener('change',()=>this.update(),options);
if(!this.preview){this.form.addEventListener('keydown',event=>{if(event.key==='Enter'&&!event.isComposing&&event.keyCode!==229&&this.phase!=='review'&&event.target.tagName==='INPUT'){event.preventDefault();this.confirm();}},options);this.form.addEventListener('submit',event=>{if(this.phase!=='review'||!event.submitter?.hasAttribute('data-send')){event.preventDefault();this.confirm();}},options);}
this.update();
}
update(){const option=this.category.selectedOptions[0],value=this.category.value;this.querySelector('[data-context]').hidden=!value;this.querySelector('[data-context-copy]').textContent=option.dataset.hint||'';this.querySelector('[data-field=message]').placeholder=option.dataset.placeholder||'';const order=this.querySelector('[data-order]'),previous=this.querySelector('[data-previous-email]');order.hidden=!value||value==='other';order.querySelector('input').disabled=order.hidden;previous.hidden=value!=='change';previous.querySelector('input').disabled=previous.hidden;}
confirm(){const controls=Array.from(this.editor.querySelectorAll('input,select,textarea')).filter(el=>!el.disabled),invalid=controls.find(el=>!el.checkValidity());if(invalid){invalid.reportValidity();return;}const list=this.querySelector('[data-review-list]');list.replaceChildren();controls.forEach(control=>{if(!control.value.trim())return;const row=document.createElement('div'),term=document.createElement('dt'),description=document.createElement('dd');term.textContent=control.dataset.reviewLabel;description.textContent=control.tagName==='SELECT'?control.selectedOptions[0].textContent:control.value;row.append(term,description);list.append(row);});this.phase='review';this.editor.hidden=true;this.review.hidden=false;this.querySelector('[data-review-heading]').focus();}

jumpToForm(){if(this.category){this.phase='edit';this.editor.hidden=false;this.review.hidden=true;this.querySelector('[data-preview-feedback]').hidden=true;}this.querySelector('.bt-cs__form-wrap')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});this.category?.focus({preventScroll:true});}
openChat(button){
if(this.chatBusy)return;this.chatBusy=true;this.chatOrigin=button;this.chatObserver?.disconnect();clearTimeout(this.chatTimer);const status=button.closest('[data-chat-entry]').querySelector('[data-chat-status]');status.hidden=false;status.textContent=this.dataset.chatLoading;button.disabled=true;button.setAttribute('aria-busy','true');const started=Date.now();let requested=false,opened=false;
const resetButton=()=>{button.disabled=false;button.removeAttribute('aria-busy');this.chatBusy=false;};
const fail=()=>{clearTimeout(this.chatTimer);this.chatObserver?.disconnect();resetButton();status.textContent=this.dataset.chatUnavailable;status.hidden=false;status.focus();};
const check=()=>{if(!this.isConnected){resetButton();return;}const launcher=document.querySelector('[data-bt-channel-launcher]');if(!requested&&launcher&&!launcher.hidden&&typeof window.ChannelIO==='function'){requested=true;this.chatObserver=new MutationObserver(()=>{if(launcher.classList.contains('is-messenger-open')){opened=true;clearTimeout(this.chatTimer);resetButton();status.hidden=true;document.getElementById('ch-plugin-script-iframe')?.focus();}else if(opened){this.chatObserver?.disconnect();const origin=this.chatOrigin?.isConnected&&this.chatOrigin.getClientRects().length?this.chatOrigin:this.querySelector('.bt-cs__chat [data-open-chat]');origin?.focus({preventScroll:true});}});this.chatObserver.observe(launcher,{attributes:true,attributeFilter:['class']});try{window.ChannelIO('showMessenger');}catch{fail();return;}}
if(launcher?.classList.contains('is-messenger-open')){opened=true;resetButton();status.hidden=true;document.getElementById('ch-plugin-script-iframe')?.focus();return;}if(Date.now()-started>=8000){fail();return;}this.chatTimer=setTimeout(check,200);};check();
}
disconnectedCallback(){clearTimeout(this.chatTimer);this.chatObserver?.disconnect();this.chatBusy=false;if(this.chatOrigin){this.chatOrigin.disabled=false;this.chatOrigin.removeAttribute("aria-busy");}this.querySelectorAll("[data-chat-status]").forEach(status=>status.hidden=true);this.abort?.abort();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-home-banners"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let timer;
    const refreshHalloweenBanners = () => {
      let nextEnd = Infinity;
      document.querySelectorAll('[data-bt-hw26-ends-at]').forEach((banner) => {
        const end = Date.parse(banner.dataset.btHw26EndsAt);
        const ended = banner.dataset.btHw26Closed === 'true' || Date.now() >= end;
        const live = banner.querySelector('.bt-home-banners__hw26-live');
        const closed = banner.querySelector('.bt-home-banners__hw26-ended');
        if (!live || !closed || !Number.isFinite(end)) return;
        live.hidden = ended;
        closed.hidden = !ended;
        if (!ended) nextEnd = Math.min(nextEnd, end);
      });
      clearTimeout(timer);
      if (Number.isFinite(nextEnd)) timer = setTimeout(refreshHalloweenBanners, Math.min(Math.max(nextEnd - Date.now(), 0) + 50, 2147483647));
    };
    refreshHalloweenBanners();
    document.addEventListener('DOMContentLoaded', refreshHalloweenBanners, { once: true });
    document.addEventListener('shopify:section:load', refreshHalloweenBanners);
    document.addEventListener('visibilitychange', refreshHalloweenBanners);
    window.addEventListener('pageshow', refreshHalloweenBanners);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-home-slides-v10"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-home-slides-v10')) {
    customElements.define('bt-home-slides-v10', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.pauseButton = this.querySelector('[data-pause]');
        this.current = 0;
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.editing = false;
        this.suppressClick = false;
        this.addEventListener('click', event => {
          if (this.suppressClick) { event.preventDefault(); this.suppressClick = false; return; }
          const control = event.target.closest('button');
          if (!control) return;
          if (control.hasAttribute('data-dot')) this.show(Number(control.dataset.dot), true);
          else if (control.hasAttribute('data-step')) this.show(this.current + Number(control.dataset.step), true);
          else if (control.hasAttribute('data-pause')) {
            this.paused = !this.paused;
            control.setAttribute('aria-pressed', String(this.paused));
            control.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
            control.firstElementChild.textContent = this.paused ? '▷' : 'Ⅱ';
            this.restart();
          }
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1), true);
          }
        }, options);
        this.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'touch' || event.target.closest('button')) return;
          this.pointer = { x: event.clientX, y: event.clientY };
        }, options);
        this.addEventListener('pointerup', event => {
          if (!this.pointer) return;
          const dx = event.clientX - this.pointer.x;
          const dy = event.clientY - this.pointer.y;
          this.pointer = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
            this.suppressClick = true;
            this.show(this.current + (dx < 0 ? 1 : -1), true);
            clearTimeout(this.swipeTimer);
            this.swipeTimer = setTimeout(() => { this.suppressClick = false; }, 400);
          }
        }, options);
        this.addEventListener('pointercancel', () => { this.pointer = null; }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.stop(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.start(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.stop(); }, options);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); if (!this.focused) this.start(); }, options);
        document.addEventListener('visibilitychange', () => { this.refreshHalloween(); this.restart(); }, options);
        window.addEventListener('pageshow', () => { this.refreshHalloween(); }, options);
        window.addEventListener('resize', () => { this.restart(); }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.editing = true; this.stop(); this.show(index); }
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) { this.editing = false; this.start(); }
        }, options);
        this.refreshHalloween(); this.show(0); this.start();
      }
      disconnectedCallback() { this.stop(); clearTimeout(this.swipeTimer); clearTimeout(this.halloweenTimer); this.abort?.abort(); }
      refreshHalloween() {
        clearTimeout(this.halloweenTimer);
        let nextEnd = Infinity;
        this.querySelectorAll('[data-hw26-ends-at]').forEach(slide => {
          const end = Date.parse(slide.dataset.hw26EndsAt);
          const ended = slide.dataset.hw26Closed === 'true' || Date.now() >= end;
          slide.querySelector('.bt-top10__hw-live').hidden = ended;
          slide.querySelector('.bt-top10__hw-ended').hidden = !ended;
          if (!ended) nextEnd = Math.min(nextEnd,end);
        });
        if (Number.isFinite(nextEnd)) this.halloweenTimer = setTimeout(() => this.refreshHalloween(), Math.min(Math.max(nextEnd-Date.now()+50,50),2147483647));
      }
      show(index, restart = false) {
        if (!this.slides.length) return;
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { const active = i === this.current; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); slide.inert = !active; });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.current)));
        if (restart) this.restart();
      }
      restart() { this.stop(); this.start(); }
      start() {
        const seconds = Number(this.dataset.autoplaySeconds || 0);
        if (this.timer || seconds <= 0 || this.slides.length < 2 || this.paused || this.hovered || this.focused || this.editing || document.hidden || matchMedia('(max-width:767px), (prefers-reduced-motion:reduce)').matches) return;
        this.timer = setInterval(() => this.show(this.current + 1), seconds * 1000);
      }
      stop() { clearInterval(this.timer); this.timer = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-series12-case-feature"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      if (root.dataset.initialised) return;
      root.dataset.initialised = 'true';
      const cards = Array.from(root.querySelectorAll('[data-product-card]'));
      const filters = root.querySelector('[data-filters]');
      const empty = root.querySelector('[data-empty]');
      const status = root.querySelector('[data-filter-status]');
      const countSuffix = root.querySelector('[data-count-suffix]').textContent;
      const state = { size: 'all', type: 'all' };
      const render = () => {
        let count = 0;
        cards.forEach((card) => {
          const suffix = state.size === 'all' ? 'default' : state.size;
          const url = suffix === 'default' ? card.dataset.defaultUrl : card.getAttribute(`data-url-${suffix}`);
          const price = suffix === 'default' ? card.dataset.defaultPrice : card.getAttribute(`data-price-${suffix}`);
          const available = suffix === 'default' ? card.dataset.defaultAvailable : card.getAttribute(`data-available-${suffix}`);
          const matchesType = state.type === 'all' || card.dataset.productType === state.type;
          card.hidden = !matchesType || !url;
          if (!card.hidden) count += 1;
          card.querySelectorAll('[data-product-link]').forEach((link) => {
            if (url) link.setAttribute('href', url);
            else link.removeAttribute('href');
          });
          card.querySelector('[data-card-price]').textContent = price || card.dataset.defaultPrice;
          card.querySelector('[data-card-stock]').hidden = available === 'true';
          card.querySelectorAll('[data-card-size]').forEach((link) => {
            if (link.dataset.cardSize === state.size) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
        });
        root.querySelectorAll('[data-size]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.size === state.size)));
        root.querySelectorAll('[data-type]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.type === state.type)));
        empty.hidden = count > 0;
        status.textContent = `${count}${countSuffix}`;
      };
      filters.hidden = false;
      root.addEventListener('click', (event) => {
        const target = event.target.closest('[data-size], [data-type], [data-size-jump], [data-type-jump]');
        if (!target || !root.contains(target)) return;
        if (target.hasAttribute('data-size')) state.size = target.dataset.size;
        if (target.hasAttribute('data-type')) state.type = target.dataset.type;
        if (target.hasAttribute('data-size-jump')) { state.size = target.dataset.sizeJump; state.type = 'all'; }
        if (target.hasAttribute('data-type-jump')) { state.type = target.dataset.typeJump; state.size = 'all'; }
        render();
      });
      render();
    };
    document.querySelectorAll('[data-series12-feature]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-series12-feature]');
      if (root) initialise(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt_cs_chronos_guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('#bt-cs-chronos-guide [data-bt-chronos-chat]');
    if (!link || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (typeof window.ChannelIO !== 'function') return;
    try {
      window.ChannelIO('showMessenger');
      event.preventDefault();
    } catch (error) {
      return;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt_cs_sirius_guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('#bt-cs-sirius-guide [data-bt-sirius-chat]');
    if (!link || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (typeof window.ChannelIO !== 'function') return;
    try {
      window.ChannelIO('showMessenger');
      event.preventDefault();
    } catch (error) {
      return;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuntom-category-links"] && !Shopify.designMode) return;
  try {
    
/* 必要なJavaScriptをここに追加 */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
